<template>
  <a-drawer :title="title" width="60%" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="onClose">
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <!-- 基本信息 -->
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="动作ID">{{ detailData.id || '-' }}</a-descriptions-item>
          <a-descriptions-item label="订单ID">{{ detailData.orderId || '-' }}</a-descriptions-item>
          <a-descriptions-item label="动作类型">
            <a-tag :color="getTypeColor(detailData.type)">{{ getTypeText(detailData.type) }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="动作状态">
            <a-tag :color="getStateColor(detailData.state)">{{ getStateText(detailData.state) }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ detailData.createTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="部门ID">{{ detailData.deptId || '-' }}</a-descriptions-item>
        </a-descriptions>

        <!-- 内容信息 -->
        <a-descriptions title="内容信息" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item label="选项内容">{{ detailData.optionContent || '-' }}</a-descriptions-item>
          <a-descriptions-item label="描述说明">{{ detailData.description || '-' }}</a-descriptions-item>
          <a-descriptions-item label="处理说明">{{ detailData.handleDescription || '-' }}</a-descriptions-item>
          <a-descriptions-item label="备注">{{ detailData.remark || '-' }}</a-descriptions-item>
        </a-descriptions>

        <!-- 处理信息 -->
        <a-descriptions title="处理信息" :column="2" bordered style="margin-top: 16px" v-if="detailData.handleUserId">
          <a-descriptions-item label="处理人员ID">{{ detailData.handleUserId || '-' }}</a-descriptions-item>
        </a-descriptions>

        <!-- 状态时间线 -->
        <a-card title="状态时间线" style="margin-top: 16px">
          <a-timeline>
            <a-timeline-item color="green">
              <p style="font-weight: bold; margin-bottom: 4px">动作创建</p>
              <p style="color: #666; margin-bottom: 4px">创建了{{ getTypeText(detailData.type) }}动作</p>
              <p style="color: #999; font-size: 12px">{{ detailData.createTime || '-' }}</p>
            </a-timeline-item>

            <a-timeline-item :color="getTimelineColor(detailData.state)">
              <p style="font-weight: bold; margin-bottom: 4px">当前状态</p>
              <p style="color: #666; margin-bottom: 4px">{{ getStateText(detailData.state) }}</p>
              <p style="color: #999; font-size: 12px" v-if="detailData.handleDescription">
                处理说明：{{ detailData.handleDescription }}
              </p>
            </a-timeline-item>
          </a-timeline>
        </a-card>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="onClose">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getActionDetail } from '@/api/repairModule/orderAction'

export default {
  name: 'OrderActionDetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      title: '订单动作详情',
      detailData: {},
      typeMap: {
        0: '取消订单',
        1: '跟单',
      },
      typeColorMap: {
        0: 'red',
        1: 'blue',
      },
      stateMap: {
        0: '发起',
        1: '处理中',
        2: '处理完成',
        3: '取消',
      },
      stateColorMap: {
        0: 'orange',
        1: 'blue',
        2: 'green',
        3: 'red',
      },
    }
  },
  methods: {
    /**
     * 显示抽屉
     * @param {Object} record - 动作记录
     */
    show(record) {
      this.visible = true
      this.title = `订单动作详情 - ID: ${record.id}`
      this.loadDetail(record.id)
    },

    /**
     * 隐藏抽屉
     */
    hide() {
      this.visible = false
      this.detailData = {}
    },

    /**
     * 关闭抽屉
     */
    onClose() {
      this.hide()
    },

    /**
     * 加载详情数据
     * @param {number} id - 动作ID
     */
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getActionDetail({ id })
        this.detailData = response.data || {}
      } catch (error) {
        console.error('加载订单动作详情失败:', error)
        this.$message.error('加载订单动作详情失败')
      } finally {
        this.loading = false
      }
    },

    /**
     * 获取类型文本
     * @param {number} type - 类型值
     * @returns {string} 类型文本
     */
    getTypeText(type) {
      return this.typeMap[type] || '-'
    },

    /**
     * 获取类型颜色
     * @param {number} type - 类型值
     * @returns {string} 颜色值
     */
    getTypeColor(type) {
      return this.typeColorMap[type] || 'default'
    },

    /**
     * 获取状态文本
     * @param {number} state - 状态值
     * @returns {string} 状态文本
     */
    getStateText(state) {
      return this.stateMap[state] || '-'
    },

    /**
     * 获取状态颜色
     * @param {number} state - 状态值
     * @returns {string} 颜色值
     */
    getStateColor(state) {
      return this.stateColorMap[state] || 'default'
    },

    /**
     * 获取时间线颜色
     * @param {number} state - 状态值
     * @returns {string} 颜色值
     */
    getTimelineColor(state) {
      const colorMap = {
        0: 'orange',
        1: 'blue',
        2: 'green',
        3: 'red',
      }
      return colorMap[state] || 'gray'
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.ant-descriptions {
  margin-bottom: 0;
}

.ant-card {
  margin-bottom: 16px;
}

.ant-card:last-child {
  margin-bottom: 0;
}
</style>
